import { buildProps, definePropType } from '@lit-element/utils'
import type { ExtractPropTypes } from 'vue'
import type wheel from './wheel.vue'

export const wheelProps = buildProps({
  /**
   * @description 绑定值，用于双向绑定
   */
  modelValue: {
    type: definePropType<any>([String, Number]),
    required: true,
  },
  /**
   * @description 是否插入空选项
   */
  insertEmpty: {
    type: String,
    default: '',
  },
  /**
   * @description 选项列表
   */
  option: {
    type: definePropType<Array<{ value: any; label: string; disabled?: any }>>(
      Array
    ),
    required: true,
  },
  /**
   * @description 是否可以点击选择
   */
  selectable: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 是否展示箭头
   */
  isShowArrow: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 滚轮状态
   */
  type: {
    type: String,
    values: ['success', 'warning', 'error', 'default'],
    default: 'default',
  },
  itemHeight: {
    type: Number,
    default: 27,
  },
  /**
   * @description 可见项目数
   */
  visibleItems: {
    type: Number,
    default: 5,
  },
} as const)
export type WheelProps = ExtractPropTypes<typeof wheelProps>
export type WheelInstance = InstanceType<typeof wheel>
